import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import intl from 'react-intl-universal';
import styles from './styles';

const SelectWrapper = ({
  options,
  value,
  defaultValue,
  renderValue,
  renderRemove,
  onChange,
  multi,
  label,
  required,
  placeholder,
  disabled,
  loadOptions,
  ...props
}) => {
  const selectRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = input => {
    onChange(input || []);
  };

  let labelClasses = 'float-label';
  if (isFocused || (value instanceof Array ? value.length > 0 : Boolean(value))) {
    labelClasses += ' float-label-shrink';
  }

  return (
    <React.Fragment>
      <div className={'select-wrapper'}>
        <div className={'label-placeholder'} />
        <AsyncSelect
          classNamePrefix="select-wrapper-control"
          ref={selectRef}
          label={''}
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          isMulti={multi}
          components={{
            MultiValueLabel: renderValue,
            MultiValueRemove: renderRemove,
            DropdownIndicator: props => (props.selectProps.menuIsOpen ? <ExpandLess /> : <ExpandMore />),
            IndicatorSeparator: () => null,
            ClearIndicator: () => null,
          }}
          styles={styles}
          defaultOptions={options}
          loadOptions={loadOptions}
          onChange={handleChange}
          onBlur={() => setIsFocused(false)}
          onFocus={() => setIsFocused(true)}
          noOptionsMessage={() => intl.get('autocomplete.noResults')}
          hideSelectedOptions
          closeMenuOnSelect
          isDisabled={disabled}
        />
        <label onClick={() => selectRef.current.focus()} className={labelClasses}>
          {label}
          {required && <span> *</span>}
        </label>
      </div>
    </React.Fragment>
  );
};

SelectWrapper.propTypes = {
  /** Classname to be applied to SelectWrapper */
  className: PropTypes.string,
  /** Default value to seed uncontrolled component */
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Value to seed uncontrolled component */
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Floating label */
  label: PropTypes.string.isRequired,
  /** Options used to load in Select data */
  options: PropTypes.array.isRequired,
  /** Function to override default value rendering */
  renderValue: PropTypes.func.isRequired,
  /** Function to override default remove icon rendering */
  renderRemove: PropTypes.func.isRequired,
  /** Callback function that fires when autocomplete adds/removes values */
  onChange: PropTypes.func.isRequired,
  /** Enable multi select */
  multi: PropTypes.bool,
  /** Enable asterisk by label */
  required: PropTypes.bool,
  /** Placeholder */
  placeholder: PropTypes.string,
  /** Disable the select */
  isDisabled: PropTypes.bool,
};

SelectWrapper.defaultProps = {
  onChange: null,
  renderValue: null,
};

export default SelectWrapper;
